var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompletedEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 114
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-completed-empty_svg__a",
    x1: "95.577%",
    x2: "3.352%",
    y1: "4.423%",
    y2: "96.648%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#AFB3BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CFCFCF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M0 107.899h15.211"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ic-completed-empty_svg__a)",
    stroke: "#202E4A",
    strokeWidth: 3,
    d: "M45.681 35.232H83.32A7.681 7.681 0 0191 42.914v57.304a7.681 7.681 0 01-7.681 7.681H45.68a7.681 7.681 0 01-7.68-7.681V42.914a7.681 7.681 0 017.681-7.682z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeWidth: 3,
    d: "M56.954 0h15.387a2.954 2.954 0 012.955 2.954v32.078H54V2.954A2.954 2.954 0 0156.954 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M54 13.811v-9.56c0-1.132.917-2.049 2.048-2.049h17.2c1.13 0 2.048.917 2.048 2.048v9.63"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 93.004,
    cy: 6.363,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 2,
    rx: 3.258,
    ry: 3.594
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.65,
    cy: 87.693,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 2,
    rx: 4.397,
    ry: 4.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 112.172,
    cy: 55.796,
    fill: "#202E4A",
    rx: 2.693,
    ry: 2.971
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.53,
    cy: 24.585,
    fill: "#202E4A",
    rx: 1.629,
    ry: 1.797
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M23 107.899h44.112m8.888 0h23.582"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 78,
    r: 20,
    fill: "#FFF",
    stroke: "#202E4A",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#202E4A",
    strokeLinecap: "round",
    strokeWidth: 3.354,
    d: "M94 72L81.272 84.895a.498.498 0 01-.704-.005L76 80.262"
  }))));
}
export default SvgIcCompletedEmpty;